const Eye = ({ size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <path
        d="M6.359 8.243C4.852 9.5 3.799 10.977 3.266 11.82a9.59 9.59 0 0 0-.11.178V12l.029.049.08.13c.533.843 1.587 2.32 3.094 3.577C7.863 17.012 9.757 18 12 18c2.244 0 4.138-.988 5.642-2.243 1.506-1.257 2.56-2.734 3.093-3.578a10.444 10.444 0 0 0 .11-.178V12a10.444 10.444 0 0 0-.11-.178c-.533-.844-1.587-2.32-3.093-3.578C16.138 6.988 14.244 6 12 6c-2.243 0-4.137.988-5.641 2.243ZM5.077 6.707C6.806 5.265 9.14 4 12 4c2.862 0 5.195 1.265 6.924 2.707 1.726 1.441 2.91 3.107 3.502 4.046l.024.038c.118.185.27.425.348.762a2.16 2.16 0 0 1 0 .894c-.077.337-.23.577-.348.762l-.024.038c-.593.939-1.776 2.605-3.502 4.046C17.195 18.735 14.862 20 12 20c-2.861 0-5.194-1.265-6.923-2.707-1.726-1.441-2.91-3.107-3.502-4.046a12.644 12.644 0 0 0-.024-.038c-.118-.185-.27-.425-.348-.762a2.159 2.159 0 0 1 0-.894c.077-.337.23-.577.348-.762l.024-.038c.592-.939 1.776-2.605 3.502-4.046ZM12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z"
        fillRule="evenodd"
        fill="currentColor"
      />
    </svg>
  );
};

export default Eye;
